module.exports = __webpack_public_path__ + "img/left.22bd3e29.png";